import { Helmet } from "react-helmet-async";
import { useEffect, useState } from "react";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { useAlert } from "../../../../context/AlertContext";
import { useWebsiteName } from "../../../../context/WebsiteNameContext";
import {
  Card,
  Button,
  Col,
  Row,
  Container,
  Tabs,
  Tab,
  Form
} from "react-bootstrap";
import TableForm from "../../../../components/TableForm";
import ConfirmModal from "../../../../components/ConfirmModal";
import {
  getServiceRequest,
  addEditServiceRequest
} from "../../../../commons/ServiceRequest";
import TechnicianReceiveService from "../../../../services/technicianreceive.service";
import { formatInputDate } from "../../../../utils/Time";
import { formatDate, formatDateTime } from "../../../../commons/FormatValue";
import handleChangeWebsiteTab from "../../../../commons/ChangeWebsiteTab";
import TechScheduleCusService from "../../../../services/techschedulecus.service";
import TableForm2s from "../../../../components/TableFormScrb";

export default function EditCustomer() {
  const { id } = useParams();
  const navigate = useNavigate();
  const { state } = useLocation();
  const { showAlert } = useAlert();
  const { websiteName, setWebsiteName } = useWebsiteName();
  const [loading, setLoading] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const [data, setData] = useState([]);
  const [selectedTab, setSelectedTab] = useState("JobDetails");
  const [dataModal, setDataModal] = useState({ Array: [] });
  const [validated, setValidated] = useState(false);

  const columns = [
    {
      name: "Seq_No",
      label: "เลขที่ใบสั่งงาน",
      format: (row) => formatDate(row?.Tech_Rev_Date),
      readOnly: true
    },
    {
      name: "Cus_Code",
      label: "รหัสลูกค้า/สาขา",
      readOnly: true,
      // size: 1
    },
    {
      name: "Branch_No",
      label: "เลขที่สาขา",
      readOnly: true,
    },
    {
      name: "Cus_Name",
      label: "ชื่อลูกค้า/สาขา",
      readOnly: true,
      width: "200px"
    },
    {
      name: "Job_Actual_Date",
      label: "วันที่เข้างาน",
      readOnly: true,
      format: (row) => formatDate(row?.Job_Actual_Date),
    },
    {
      name: "Tech_Name",
      label: "ผู้ติดต่อ",
      readOnly: true,
    },
    {
      name: "Tech_Tel",
      label: "เบอร์ติดต่อ",
      readOnly: true,
    },
    {
      name: "Appointment_Tel_Date",
      label: "วันเวลาโทรนัดหมาย",
      type: "datetime-local",
      width: "200px"
    },
    {
      name: "Appointment_Date",
      label: "วันเวลานัดหมาย",
      type: "datetime-local",
      width: "200px"
    },
    {
      name: "Work_Actual_Date",
      label: "วันเวลาเข้างานจริง",
      type: "datetime-local",
      width: "200px"
    },
  ];

  useEffect(() => {
    // handleChangeTab("CheckJobDetails");
    setTimeout(() => setWebsiteName("รายละเอียดข้อมูลที่จะแก้ไข"), 300);
    getData();
  }, []);

  // useEffect(() => {
  //   pSetData(pData);
  // }, [pData]);

  const getData = () => {
    getServiceRequest({
      showAlert,
      setLoading,
      serviceRequest: TechScheduleCusService.getScheduleCustomer(id),
      callback: (res) => pSetData(res)
    });
  };

  const pSetData = (vData) => {
    const newArray = [vData].map((items) => ({
      Id: items.id,
      Seq_No: items.TechnicianPlans.SeqOthersJob?.Seq_Oth_No ||
        items.TechnicianPlans.SeqPmJob?.Seq_Pm_No ||
        items.TechnicianPlans.SeqRepairJob?.Seq_Serv_No ||
        items.TechnicianPlans.SeqInstallJob?.Seq_Inst_No,
      Cus_Code: items.TechnicianPlans.SeqOthersJob.InformOtherJob?.Customer.Cus_Code,
      Cus_Name: items.TechnicianPlans.SeqOthersJob.InformOtherJob?.Customer.Cus_Name,
      Branch_No: items.TechnicianPlans.SeqOthersJob.InformOtherJob?.Cus_NumBranch,
      Job_Actual_Date: formatInputDate(items.TechnicianPlans?.job_actual_date, "Local").date,
      Tech_Name: items.TechnicianPlans?.Technician.Tech_Mas_Name,
      Tech_Tel: items.TechnicianPlans?.Technician.Tech_Mas_Tel,
      Appointment_Tel_Date: formatDateTime(new Date(items.appointment_tel_date), "YYYY-MM-DD HH:mm"),
      Appointment_Date: formatDateTime(new Date(items.appointment_date), "YYYY-MM-DD HH:mm"),
      Work_Actual_Date: formatDateTime(new Date(items.work_actual_date), "YYYY-MM-DD HH:mm")
    }));
    setData(newArray);
  };

  const handleValidated = (event) => {
    event.preventDefault();
    const form = event.currentTarget;

    if (!form.checkValidity()) {
      event.stopPropagation();
      setValidated(true);
    } else {
      setShowModal(true);
    }
  };

  const handleChangeTab = (key) => {
    handleChangeWebsiteTab({
      key,
      setWebsiteName,
      tabNames: {
        acceptance: "ทีมงานรับงาน",
        JobDetails: "ข้อมูลการรับงาน",
        CheckEquipment: "ตรวจรับอุปกรณ์/อะไหล่",
        CheckJobDetails: "ตรวจสอบรายละเอียดงาน",
        EventplaningCalendar: "ปฏิทินงานช่าง",
      }
    });
  };

  const handleSubmit = async (event, { dataCallback, showCallback }) => {
    event.preventDefault();
    setShowModal(showCallback);

    if (dataCallback) {
      try {
        await submitEdit(id, dataCallback);
      } catch (error) {
        console.error(error);
      }
    }
  };

  const submitEdit = async (id, body) => {
    addEditServiceRequest({
      showAlert,
      setLoading,
      serviceRequest: TechScheduleCusService.editScheduleCustomer(id, body),
      navigated: (navi) =>
        navi &&
        navigate("/service_work/acceptance/customer")
    });
  };

  return (
    <>
      <Helmet>
        <title>{websiteName}</title>
        <meta name="description" content="Head Event Planning Page" />
      </Helmet>

      <Container fluid className="p-0" id="tab_team">
        <Tabs
          justify
          defaultActiveKey={state?.name || "CheckJobDetails"}
          onSelect={(k) => handleChangeTab(k)}
          className="mb-3"
        >
          <Tab eventKey="acceptance" title="ทีมงานรับงาน" disabled
          />
          <Tab eventKey="JobDetails" title="ข้อมูลการรับงาน" disabled
          />
          <Tab eventKey="CheckEquipment" title="ตรวจรับอุปกรณ์/อะไหล่" disabled
          />
          <Tab eventKey="CheckJobDetails" title="ตรวจสอบรายละเอียดงาน">
            <Form noValidate validated={validated} onSubmit={handleValidated}>
              <Card className="m-1 mb-4 p-4 border-0">
                <Card.Header className="p-3 d-flex justify-content-between align-items-center border-bottom-0 bg-transparent">
                  <Card.Title className="mb-0 fs-2 text-dark">
                    รายละเอียดข้อมูลที่จะติดต่อและนัดหมายลูกค้า
                  </Card.Title>
                </Card.Header>

                <div style={{ overflowX: "auto" }}>
                  <TableForm2s
                    data={data}
                    defaultData={[]}
                    columns={columns}
                    pending={loading}
                    editForm={true}
                    pagination={false}
                    onChangeCallback={(newData) => {
                      const aForSave = newData.map((item) => ({
                        appointment_tel_date: new Date(item.Appointment_Tel_Date).toISOString(),
                        appointment_date: new Date(item.Appointment_Date).toISOString(),
                        work_actual_date: new Date(item.Work_Actual_Date).toISOString(),
                      }));
                      setData(newData);
                      setDataModal({ Array: aForSave[0] });
                    }}
                  />

                </div>

                <Row className="justify-content-end mt-3 py-2">
                  <Col className="col-auto">
                    <Button
                      type="submit"
                      variant="success"
                      className="me-2 px-5 py-2 text-dark rounded-pill"
                      onClick={() => setShowModal(!showModal)}
                    >
                      บันทึกการแก้ไข
                    </Button>
                    <ConfirmModal
                      show={showModal}
                      data={dataModal.Array}
                      content={"save"}
                      onSubmitCallback={handleSubmit}
                    />
                    <Button
                      variant="outline-secondary"
                      className="px-5 py-2 text-dark border-dark border-opacity-50 rounded-pill"
                      onClick={() =>
                        navigate("/service_work/acceptance/customer", {
                          state: { name: "CheckJobDetails" }
                        })
                      }
                    >
                      ย้อนกลับ
                    </Button>
                  </Col>
                </Row>
              </Card>
            </Form>
          </Tab>
          <Tab eventKey="EventplaningCalendar" title="ปฏิทินงานช่าง" disabled
          />
        </Tabs>
      </Container>
    </>
  );
}
